import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import AppModal from '../common/AppModal';

const MarkInvoicePaidModal = ({ show, row, onHide, onExited, onSubmit, submitting }) => {
  const hasMultipleInvoices = row?.orderHasMultipleInvoices === true;

  const alertText = row
    ? hasMultipleInvoices
      ? 'This order has more than one invoice. Please review and update status inside the service view.'
      : `Mark invoice ${row.invoiceNumber || '—'} as paid for file ${row.fileNo || '—'}?`
    : '';

  return (
    <AppModal
      show={show}
      onHide={onHide}
      onExited={onExited}
      onSubmit={onSubmit}
      heading={hasMultipleInvoices ? 'Multiple Invoices' : 'Mark as Paid'}
      submitLabel={hasMultipleInvoices ? 'OK' : 'Mark Paid'}
      submitting={submitting}
      showCancelButton={!hasMultipleInvoices}
    >
      <Row>
        <Col className="text-center">
          <ExclamationTriangleFill className="text-danger" size={30} />
          <h6 className="mt-3">{alertText}</h6>
        </Col>
      </Row>
    </AppModal>
  );
};

export default MarkInvoicePaidModal;
